import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use local storage for persistence
import userProfileReducer from "./userProfile/userProfileSlice";
import clientTokenReducer from "./token/clientTokenSlice";
import projectReducer from "./project/projectSlice";
import answersReducer from "./introductionWizard/answersSlice"; // Import the answers slice
import workProductsReducer from "./workProducts/workProductsSlice";
import canvasReducer from "./canvas/canvasSlice";
import workProductProcessorReducer from "./workProductsProcessor/WorkProductProcessorSlice";
import vectorFileReducer from "./vectorFiles/vectorFilesSlice"; // Import the vector files slice
import workProductsDocumentsReducer from "./workProductsProcessor/WorkProductDocumentsSlice";
import chatsReducer from "./chats/chatsSlice";
import activeEditorReducer from "./activeEditor/activeEditorSlice";
import documentContextReducer from "./documentContext/documentContextSlice";
import workProductReducer from "./workproduct/workProductSlice";
import userStoriesReducer from "./userStories/userStoriesSlice";

// Persist configuration
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["answers", "clientToken", "userProfiles"] // Only persist these slices
};

// Combine reducers
const rootReducer = combineReducers({
    userProfiles: userProfileReducer,
    projects: projectReducer,
    clientToken: clientTokenReducer,
    answers: answersReducer,
    workProducts: workProductsReducer,
    chats: chatsReducer,
    canvas: canvasReducer,
    workProductProcessor: workProductProcessorReducer, //TODO: POINT TO NEW JOB PROCESSOR
    workProductDocuments: workProductsDocumentsReducer,
    vectorFile: vectorFileReducer, //TODO: POINT TO NEW JOB PROCESSOR
    activeEditor: activeEditorReducer,
    documentContext: documentContextReducer,
    workProductByPhase: workProductReducer,
    userStories: userStoriesReducer
});

// Persist the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"] // Ignore persist-related actions
            }
        })
});

// Types for state and dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store); // Create the persistor for persistence

export default store;
